import { Fragment, useEffect, useState, useRef } from "react";
import basvuruDetailLists from "../../services/basvuruDetailLists";
import basvuruAnaDurumList from "../../services/basvuruAnaDurumList"
import { Table, Card, Row, Col, Drawer, Modal, Spin, Input, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import history from "../../history";
import queryString from 'query-string';
import { DATE_FORMAT } from "../../constants";
import moment from "moment";
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import ReactExport from "react-export-excel";
import ExcelExport from './../ExcelExport';
import { FileExcelOutlined, OrderedListOutlined } from "@ant-design/icons";
import BasvuruAnaOzetFilterRow from "../BasvuruAnaOzetFilterRow/BasvuruAnaOzetFilterRow";
import useColumns from "../../hooks/useColumns";
import basvuruStateZamanlariList from "../../services/basvuruStateZamanlariLists";
import getParametreDeger from "../../services/getParametreDeger";
import {kurumAdi} from '../Helpers/Enum';

const parsed = queryString.parse(history.location.search);

const BasvuruAnaOzetList = () => {
  const [dates, setDates] = useState([moment(), moment()]);
  const [expandedBasvuruAnaOzet, setExpandedBasvuruAnaOzet] = useState([]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  const [visible, setVisible] = useState(false);
  let [basvuruDetails, setBasvuruDetails] = useState([]);
  const [spining, setSpining] = useState(false);
  let [searchText, setSearchText] = useState("");
  let [searchInput, setsearchInput] = useState("");
  let [searchedColumn, setsearchedColumn] = useState("");
  const [basvuruStateList, setBasvuruStateList] = useState([]);
  const [filtredBasvuruAnOzet, setFiltredBasvuruAnaOzet] = useState([]);
  const [basvuruAnaOzet, setBasvuruAnaOzet] = useState([]);
  const [filterBasvuruAnaOzet, setFilterBasvuruAnaOzet] = useState([]);
  const [basvuruColumns, setBasvuruColumns] = useState([]);
  const [totalCountBasvuruAna, setTotalCountBasvuruAna] = useState(0);
  const { basvuruDetailColumns, basvuruSurecGecmisColumns } = useColumns();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCompanyIlOzelIdare, setIsCompanyIlOzelIdare] = useState(false);
  const [companyName, setCompanyName] = useState([]);

  const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item => { return parseInt(item) });


  const basvuruDetailColumnsWithIslem = [...basvuruDetailColumns];
  basvuruDetailColumnsWithIslem.push({
    title: 'İşlem',
    key: 'key',
    dataIndex: 'key',
    render: (text, record) => (
      <TooltipAnd title="Süreç Geçmişi Görüntüle">
        <Button type="primary" onClick={() => { openModalBasvuruStateList(record.objectid, record.altSurecTipiId) }} shape="circle" icon={<OrderedListOutlined />} />
      </TooltipAnd>
    ),
  })
  
  if(companyName == kurumAdi.Cesme){  
      basvuruDetailColumnsWithIslem.splice(11, 0, {
        title: 'Mimari Sorumlu Kişi',
        dataIndex: 'mimariSorumlusu',
        key: 'mimariSorumlusu',
        sorter: (a, b) => {
            a.mimariSorumlusu = a.mimariSorumlusu || '';
            b.mimariSorumlusu = b.mimariSorumlusu || '';
            return a.mimariSorumlusu.localeCompare(b.mimariSorumlusu)
        },
      })
    }

  function formatMyMoney(price) {

    var currency_symbol = "₺"

    var formattedOutput = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2,
    });

    return formattedOutput.format(price).replace(currency_symbol, '')
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Ara `}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Ara
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Sıfırla
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
                searchText= selectedKeys[0];
                searchedColumn= dataIndex;
              }}
          >
            Filtre
          </Button> */}
        </Space>
      </div>
    ),
    // filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        text
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    searchText = selectedKeys[0];
    searchedColumn = dataIndex;
  };

  const handleReset = clearFilters => {
    clearFilters();
    searchText = '';
  };


  const showModal = () => {

    setIsModalVisible(true);
  };


  let generalBasvuruColumns = [
    {
      title: 'Başvuru No',
      dataIndex: 'objectid',
      key: 'objectid',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.objectid - b.objectid,
      ...getColumnSearchProps('objectid'),
    },
    {
      title: 'Belge Türü',
      dataIndex: 'belge_turu_adi',
      key: 'belge_turu_adi',
      sorter: (a, b) => { return a.belge_turu_adi.localeCompare(b.belge_turu_adi) },
      ...getColumnSearchProps('belge_turu_adi'),
    },
    {
      title: 'İlçe',
      dataIndex: 'ilce_adi',
      key: 'ilce_adi',
      sorter: (a, b) => { return a.ilce_adi.localeCompare(b.ilce_adi) },
      ...getColumnSearchProps('ilce_adi'),
    },
    {
      title: 'Mahalle',
      dataIndex: 'geomahalle_adi',
      key: 'geomahalle_adi',
      sorter: (a, b) => { return a.geomahalle_adi.localeCompare(b.geomahalle_adi) },
      ...getColumnSearchProps('geomahalle_adi'),
    },
    {
      title: 'Ada/Parsel',
      dataIndex: 'adaparsel',
      key: 'adaparsel',
      sorter: (a, b) => { return a.adaparsel.localeCompare(b.adaparsel) },
      ...getColumnSearchProps('adaparsel'),
    },
    {
      title: 'Başvuru Durumu',
      dataIndex: 'basvuru_ana_durumu_adi',
      key: 'basvuru_ana_durumu_adi',
      sorter: (a, b) => { return a.basvuru_ana_durumu_adi.localeCompare(b.basvuru_ana_durumu_adi) },
      ...getColumnSearchProps('basvuru_ana_durumu_adi'),
    },
    // {
    //   title: 'Mimari Proje',
    //   dataIndex: 'mimariProje',
    //   key: 'mimariProje',
    //   sorter: (a, b) => { return a.mimariProje.localeCompare(b.mimariProje)},
    //    ...getColumnSearchProps('mimariProje'),
    // },
    // {
    //   title: 'Statik Proje',
    //   dataIndex: 'statikProje',
    //   key: 'statikProje',
    //   sorter: (a, b) => { return a.statikProje.localeCompare(b.statikProje)},
    //    ...getColumnSearchProps('statikProje'),
    // },
    // {
    //   title: 'Elektrik Proje',
    //   dataIndex: 'elektrikProje',
    //   key: 'elektrikProje',
    //   sorter: (a, b) => { return a.elektrikProje.localeCompare(b.elektrikProje)},
    //    ...getColumnSearchProps('elektrikProje'),
    // },
    // {
    //   title: 'Elektrik/Mekanik Proje',
    //   dataIndex: 'elektrikMekanikProje',
    //   key: 'elektrikMekanikProje',
    //   sorter: (a, b) => { return a.elektrikMekanikProje.localeCompare(b.elektrikMekanikProje)},
    //    ...getColumnSearchProps('elektrikMekanikProje'),
    // },
    // {
    //   title: 'Mekanik Proje',
    //   dataIndex: 'mekanikProje',
    //   key: 'mekanikProje',
    //   sorter: (a, b) => { return a.mekanikProje.localeCompare(b.mekanikProje)},
    //    ...getColumnSearchProps('mekanikProje'),
    // },
    // {
    //   title: 'Sular İdaresi Proje',
    //   dataIndex: 'sularIdaresiProje',
    //   key: 'sularIdaresiProje',
    //   sorter: (a, b) => { return a.sularIdaresiProje.localeCompare(b.sularIdaresiProje)},
    //    ...getColumnSearchProps('sularIdaresiProje'),
    // },
    // {
    //   title: 'Resmi Ruhsat',
    //   dataIndex: 'resmiRuhsat',
    //   key: 'resmiRuhsat',
    //   sorter: (a, b) => { return a.resmiRuhsat.localeCompare(b.resmiRuhsat)},
    //    ...getColumnSearchProps('resmiRuhsat'),
    // },
    {
      title: 'Başvuru Zamanı',
      dataIndex: 'BelgeBasvuruZamani',
      key: 'BelgeBasvuruZamani',
      sorter: (a, b) => moment(a.BelgeBasvuruZamani).unix() - moment(b.BelgeBasvuruZamani).unix(),
      ...getColumnSearchProps('BelgeBasvuruZamani'),
      render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
    },
    {
      title: 'Başvuru Kapanış Zamanı',
      dataIndex: 'BelgeKapanisZamani',
      key: 'BelgeKapanisZamani',
      sorter: (a, b) => moment(a.BelgeKapanisZamani).unix() - moment(b.BelgeKapanisZamani).unix(),
      ...getColumnSearchProps('BelgeKapanisZamani'),
      render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
    },
    {
      title: 'Toplam Süre(gün)',
      dataIndex: 'BelgeGecenSure',
      key: 'BelgeGecenSure',
      sorter: (a, b) => a.BelgeGecenSure - b.BelgeGecenSure,
      ...getColumnSearchProps('BelgeGecenSure'),
    },
    {
      title: 'Harç Toplamı(TL)',
      dataIndex: 'HarcToplami',
      ...getColumnSearchProps('HarcToplami'),
      sorter: (a, b) => a.HarcToplami - b.HarcToplami,
      key: 'HarcToplami',
      render: (value) => value && <div>{formatMyMoney(value)}</div>
    }
  ]

  useEffect(() => {
    getParametreDeger('EBELGE.ORTAK.COMPANY_TYPE').then(res => {
      setIsCompanyIlOzelIdare(res.data.result == 1);
    });
    getParametreDeger('EBELGE.ORTAK.COMPANY_NAME').then(res => setCompanyName(res.data.result));
    basvuruAnaDurumList().then(res => {
      setBasvuruAnaOzet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      setFilterBasvuruAnaOzet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      dynamicColumnSet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      setTotalCountBasvuruAna(res.data.result.length);
    }

    );
    setQueryDates(dates);
  }, []);


  const openModalBasvuruStateList = (basvuruId, altSurecTipiId) => {

    let filterModel = {};

    if (basvuruId !== undefined && basvuruId != null) {
      filterModel.basvuruId = basvuruId;
    }
    if (altSurecTipiId !== undefined && altSurecTipiId != null) {
      filterModel.altSurecTipiId = altSurecTipiId;
    }
    setSpining(true);
    basvuruStateZamanlariList(filterModel).then(res => { setSpining(false); console.log("Başarılı"); setBasvuruStateList(res.data.result); showModal(); }).catch(ex => setSpining(false));

  };

  const getBasvuruDetailListesi = (parentObjectId) => {
    setSpining(true);
    basvuruDetailLists(parentObjectId)
      .then(res => {
        setBasvuruDetails(res.data.result);
        setSpining(false);
      }).catch(ex => {
        setSpining(false);
      })

  }

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const expandedRowRender = (record) => {
    return <Card> <Table title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
      <ExcelExport
        fileName={'Ruhsat Başvuruları ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
        downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
        sheets={[{ data: basvuruDetails, name: 'Test', keyTitles: basvuruDetailKeyTitles }]} />
    </div>} bordered dataSource={basvuruDetails} columns={basvuruDetailColumnsWithIslem} pagination={false} /> </Card>
  };

  const dynamicColumnSet = (basvuruAnaOzet) => {
    let firstRow = basvuruAnaOzet[0];
    for (const [key, value] of Object.entries(firstRow)) {
      console.log(`${key}: ${value}`);

      if (!(generalBasvuruColumns.filter(items => items.key == key).length > 0)) {
        if (!key.includes("id")) {
          generalBasvuruColumns.push({
            title: key,
            dataIndex: key,
            key: key,
            sorter: (a, b) => {
              a[key] = a[key] || '';
              b[key] = b[key] || '';
              return a[key].localeCompare(b[key])
            },
            ...getColumnSearchProps(key),
          })
        }
      }
    }
    setBasvuruColumns(generalBasvuruColumns);
  }

  const getReportByFilter = (belgeTuruId, basvuruAnaDurumuId, basvuruNo, ilceId, geomahalleId, adaParsel) => {

    let filterModel = {};

    if (belgeTuruId !== undefined && belgeTuruId != null) {
      filterModel.belgeTuruId = [];
      filterModel.belgeTuruId.push(belgeTuruId);
    }
    if (basvuruAnaDurumuId !== undefined && basvuruAnaDurumuId != null) {
      filterModel.basvuruAnaDurumuId = basvuruAnaDurumuId;
    }
    if (basvuruNo !== undefined && basvuruNo != null) {
      filterModel.basvuruNo = basvuruNo;
    }
    if (ilceId !== undefined && ilceId != null) {
      filterModel.ilceId = ilceId;
    }
    if (geomahalleId !== undefined && geomahalleId != null) {
      filterModel.geomahalleId = geomahalleId;
    }
    if (adaParsel !== undefined && adaParsel != null) {
      filterModel.adaParsel = adaParsel;
    }
    setSpining(true);
    basvuruAnaDurumList(filterModel).then(res => { setFilterBasvuruAnaOzet(res.data.result); setTotalCountBasvuruAna(res.data.result); setSpining(false); }).catch(ex => { setSpining(false) });

    // dynamicColumnSet(filterBasvuruAnaOzet);
  }

  let opKeyTitles = basvuruColumns.map(items => { return { key: items.key, title: items.title } });
  const basvuruDetailKeyTitles = basvuruDetailColumns.map(items => { return { key: items.key, title: items.title } });

  const getBasvuruColumns = () => {
    if (!isCompanyIlOzelIdare) return basvuruColumns?.filter(s => s.key != 'ilce_adi');
    return basvuruColumns;
  }
  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
    style={{ margin: "20px" }}
    title={<h3 style={{ fontWeight: "bolder", color: "white" }}>Ruhsat Başvuru Raporları</h3>}
    className="ant-card-head-title-large"
  >
    <Row>
      <BasvuruAnaOzetFilterRow onSubmit={getReportByFilter} getIsCompanyIlOzelIdare={() => isCompanyIlOzelIdare} />


    </Row>
    <Row gutter={24}>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
        <Table bordered rowKey={"objectid"} dataSource={filterBasvuruAnaOzet}
          title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
            <ExcelExport
              fileName={'Ruhsat Başvuruları ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
              downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
              sheets={[{ data: filterBasvuruAnaOzet, name: 'Test', keyTitles: opKeyTitles }]} />
          </div>}
          columns={getBasvuruColumns()}
          onChange={
            (pagination, filters, sorter, extra) => {
              if (extra.currentDataSource.length < filterBasvuruAnaOzet.length) {
                setTotalCountBasvuruAna(extra.currentDataSource.length);
              }
              else {
                setFiltredBasvuruAnaOzet(filterBasvuruAnaOzet);
                setTotalCountBasvuruAna(filterBasvuruAnaOzet.length);
              }
            }
          }
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: totalCountBasvuruAna && totalCountBasvuruAna,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
          expandable={{
            expandedRowRender: expandedRowRender,
            expandedRowKeys: expandedBasvuruAnaOzet,
            onExpand: (expanded, record) => {
              if (expanded) {
                //request at geleni state e setle
                getBasvuruDetailListesi(record.objectid);
                setExpandedBasvuruAnaOzet([record.objectid]);
              }
              else {
                setExpandedBasvuruAnaOzet([]);
              }
            }
          }}
        />
      </Col>
      <Modal title="Başvuru Geçmişi" centered visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <Table rowKey={"stateId"} bordered dataSource={basvuruStateList} columns={basvuruSurecGecmisColumns}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: basvuruStateList && basvuruStateList.length,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
        />
      </Modal>
    </Row>
    {
    }
  </Card>
  </Spin>
}
export default BasvuruAnaOzetList;